import _Abstract from "system/abstract"

export default class Module_Filter extends _Abstract {

    constructor(el, options) {
        super(el, $.extend(true, {}, options), 'module')

        this.FADE_OUT_DURATION = 50;
        this.FADE_IN_DURATION = 100;
        this.m_bIsOurPeopleFilter = $(".-read-bio").length;

        this.initModule();


    }

    /********* Initialising ***************/

    initModule()
    {
        this.$mList = this.$el.closest(".m-list");
        this.$mListColumns = this.$el.closest(".m-list").find(".m-columns__columns");
        this.$mContainerList = this.$mList.find(".m-list__list");
        this.$elItemBtn = this.$el.find("a");
        this.$elItemSelect = this.$el.find("select")
        this.initListener();
        this.triggers();
        this.setBorders();
    }

    initListener()
    {
        this.$el.on("click","a",(e) => this.onItemClicked(e));
        this.$el.on("change","select",(e) => this.onSelectBoxChanged(e));

        if(this.m_bIsOurPeopleFilter)
        {
            $(".m-columns__column").on("click",".-read-bio, .-read-bio-mobile, .m-list__name",(e) => this.onReadBioClicked(e));
        
            if(window.location.hash)
            {
                var hashRemoved = encodeURI(window.location.hash.replace("#",""));
                var context = this;
                $(".m-list__item[data-name!='']").each(function()
                {
                    var $this = $(this);
                    var encodedDataName = encodeURI($this.data("name"));
                    if(encodedDataName === hashRemoved)
                    {
                        context.goToListItemDetail.call(context,$this,true,false);
                        return false;
                    }
                })

            }

            //Triggers the filter to display on the first item  by default
            this.$el.find(".-btns a.-active").click();

        }
        $(".-back").click((e) => this.onBackButtonClicked(e));
        this.$mList.on("click",".m-list__item.-accordion .m-list__description, .m-list__item.-accordion .m-list__avatar, .m-list__item.-accordion .-open-accordion", (e) => this.onAccordianItemClicked(e));
    }

    goToListItemDetail(_$listItem, fadeTo,_scrollToDetail)
    {
        if(!_$listItem.length)
        {
            console.log("no list item found");
            return;
        }

        // $("body").animate({scrollTop:});
        // $("body").animate({scrollTop:$(".m-profile").offset().top});

        if(typeof _scrollToDetail === "undefined")
        {
            _scrollToDetail = true;
        }

        if(typeof fadeTo === "undefined")
        {
            fadeTo = true;
        }


        this.copyListItemDetailsToDetailItem(_$listItem);

        var context = this;

        $(".m-list__list").stop(true,true);
        if(fadeTo)
        {
            this.$mContainerList.fadeOut(this.FADE_OUT_DURATION,function()
            {
                $(".m-profile").fadeIn({duration:this.FADE_IN_DURATION});
                if(_scrollToDetail)
                {
                    context.scrollToTopOfProfileElement(true);
                }
            });
            
        }
        else
        {
            this.$mContainerList.hide();
            $(".m-profile").show();
            if(_scrollToDetail)
            {
                this.scrollToTopOfProfileElement(false);
            }
        }

        this.$el.addClass('disabled');
        this.$el.find("select").prop("disabled", true);
        window.location.hash = _$listItem.data("name");


    }

    scrollToTopOfProfileElement(_bAnimateTo)
    {
        if(_bAnimateTo)
        {
            $("html,body").animate({scrollTop:$(".m-profile").offset().top});
        }
        else
        {
            $("html,body").scrollTop($(".m-profile").offset().top);
        }

    }

    onReadBioClicked(e)
    {
        e.preventDefault();//Removing this will cause the page to jump to the top, then scroll down
                           //Also causes issues with mobile
        var $listItem = $(e.currentTarget).closest(".m-list__item");
        this.goToListItemDetail($listItem);
    }

    copyListItemDetailsToDetailItem(_$item)
    {

        var classesTextToCopy = [".m-list__name",".m-list__about"];
        var classesHTMLToCopy = [".m-profile__phone",".m-profile__email"];

        for (var i = classesTextToCopy.length - 1; i >= 0; i--)
        {
            var selector = classesTextToCopy[i];
            this.copySelectorTextFromListToDetail(_$item,selector);
        }

        for (var i = classesHTMLToCopy.length - 1; i >= 0; i--)
        {
            var selector = classesHTMLToCopy[i];
            this.copySelectorHTMLFromListToDetail(_$item,selector);
        }


        this.copySocialMediaOptionsFromListItemToDetail(_$item);
        var htmlBioData = _$item.find(".m-profile__bio").html().trim();
        var dataResponsiveImageAttr = _$item.find(".m-list__avatar").data("responsive-image");
        var $profileAvatarElement = $(".m-profile").find(".m-profile__avatar");

        $profileAvatarElement.css("background-image","none");
        $profileAvatarElement.data("responsive-image",dataResponsiveImageAttr);

        var $profileBioElement = $(".m-profile").find(".m-profile__bio");
        if(htmlBioData)
        {
            $profileBioElement.html(htmlBioData);
            $profileBioElement.show();
        }
        else
        {
            $profileBioElement.hide();
        }
        $("body").trigger("responsive-image",{$responsiveImageTargets:$profileAvatarElement});
    }

    copySocialMediaOptionsFromListItemToDetail(_$item)
    {

        var $listItemTwitterElement = _$item.find(".-twitter");
        var $listItemLinkedinElement = _$item.find(".-linkedin");

        // var twitterOptions = $listItemTwitterElement.data("component-options");
        // var linkedinOptions = $listItemLinkedinElement.data("component-options");

        var $profileContainerElement = $(".m-profile");
        var $profileContainerTwitterElement = $profileContainerElement.find(".-twitter");
        var $profileContainerLinkedinElement = $profileContainerElement.find(".-linkedin");


        if($listItemTwitterElement.length)
        {

            $profileContainerTwitterElement.prop("href",$listItemTwitterElement.prop("href"));
            // $profileContainerTwitterElement.data("component-options",twitterOptions);
            $profileContainerTwitterElement.show();
        }
        else
        {
            $profileContainerTwitterElement.hide();
        }

        if($listItemLinkedinElement.length)
        {

            $profileContainerLinkedinElement.prop("href",$listItemLinkedinElement.prop("href"));
            // $profileContainerLinkedinElement.data("component-options",linkedinOptions);
            $profileContainerLinkedinElement.show();
        }
        else
        {
            $profileContainerLinkedinElement.hide();
        }


        // if(!$listItemLinkedinElement.length && !$listItemTwitterElement.length)
        // {
        //     $(".m-profile__description .m-profile__details > a").hide();
        // }
        // else
        // {
        //     $(".m-profile__description .m-profile__details > a").show();
        // }

    }


    copySelectorTextFromListToDetail(_$item, _$selector)
    {
        var value = _$item.find(_$selector).text();
        var profileSelector = _$selector.replace("m-list","m-profile");
        $(".m-profile").find(profileSelector).text(value);
    }

    copySelectorHTMLFromListToDetail(_$item, _$selector)
    {
        var value = _$item.find(_$selector).html();
        var profileSelector = _$selector.replace("m-list","m-profile");
        $(".m-profile").find(profileSelector).html(value);
    }

    onBackButtonClicked(e)
    {
        e.preventDefault();
        // history.pushState(null, null, '');
        window.location.hash = "listings";
        // $(".m-profile").css('display','none');
        // $(".m-list__list").css('display','block');

        // window.location.origin + window.location.pathname

        
        $(".m-profile").stop(true,true).fadeOut(this.FADE_OUT_DURATION,function(){
            $(".m-list__list").fadeIn({duration:this.FADE_IN_DURATION});
        });
        
        this.$el.removeClass('disabled');
        this.$el.find("select").prop("disabled", false);
    }

    onSelectBoxChanged(e)
    {
        this.changeStatus(e);
    }

    onItemClicked(e)
    {
        this.changeStatus(e);
    }

    onAccordianItemClicked(e)
    {
         console.log('click accordion');

        var $parent =   $(e.target).closest('.m-list__item');
        var $accordianItems = $('.m-list__item');


        if(!$parent.hasClass("-is-open")){
            $accordianItems.removeClass("-is-open");
            $parent.addClass("-is-open");
        } else {
            $parent.removeClass("-is-open");
        }
    }


    changeStatus(e)
    {
        e.preventDefault();
        var f;
        $(this.$el).find("a").removeClass("-active");

        if($(e.target).hasClass('c-form__select'))
        {
            f = $(e.target).val();
            $('[data-filter-option="'+f+'"]').addClass('-active');
        }
        else
        {
            f = $(e.target).attr('data-filter-option');

            this.$elItemSelect.val(f);

        }

        if($(this.$el).hasClass('disabled'))
        {
            return
        }

        var $this = $(this);
       
        $(e.target).addClass('-active');
        this.filterList(f);
    }


    filterList(option)
    {
        console.log(option);
        if(option == "all")
        {
            this.$mContainerList.find(".m-list__item").addClass('show');
        }
        else
        {
            this.$mContainerList.find(".m-list__item").removeClass('show');
            $('[data-filter-item*=";'+option+';"]').addClass('show');
        }
        this.setBorders();
    }

    setBorders()
    {

        this.$mContainerList.find(".m-list__item.show").removeClass("-no-bottom-border");
        this.$mContainerList.find(".m-list__item.show:last").addClass("-no-bottom-border");

    }

    triggers(){

        
        activateAccordion();
        $( window ).resize(function() {
            activateAccordion();
        })
    
    
        function activateAccordion(){
            if($("body").hasClass("mobile"))
            {
              $('.m-list__item').addClass('-accordion');
            }else{
                $('.m-list__item').removeClass('-accordion');
            }
        }
    }
    
}


/** WEBPACK FOOTER **
 ** ./modules/filter.js
 **/